// Action Constants

export enum ActionConstant {
	GET_LIST = 'FILE://KEYWORDS/GET_LIST',
	GET_DETAILS = 'FILE://KEYWORDS/GET_DETAILS',
	GET_STATUS = 'FILE://KEYWORDS/GET_STATUS',
	CLEAR_DETAILS = 'FILE://KEYWORDS/CLEAR_DETAILS',
	CLEAR_STATUS = 'FILE://TRADE_MANAGEMENT/CLEAR_STATUS',
	CLEAR_LIST = 'FILE://TRADE_MANAGEMENT/CLEAR_LIST',
}

// State Types

export interface List {
	count: number;
	rows: [];
}
export interface Details {
	id: number;
	name: string;
	divisionNumber: string;
	wordFilter: string;
	drawingFilter: string;
	keywordHeading: string;
	isDuplicateExcluded: boolean;
	grouping: string;
	structureTypeExclusion: string;
	skinTypeInclusion: string;
}

export interface InitialState {
	initialList: boolean;
	fetching: boolean;
	detailsFetching: boolean;
	list: [];
	total: number;
	details: Details;
	keywords: string;
	statusCode: number;
	noOfResults: number;
	totalResults: number;
}

// Action Types

export interface GetListType {
	type: ActionConstant.GET_LIST;
	data: List;
}

export interface GetDetailsType {
	type: ActionConstant.GET_DETAILS;
	data: Details;
}

export interface GetStatusType {
	type: ActionConstant.GET_STATUS;
	status: number;
}

export interface ClearDetailsType {
	type: ActionConstant.CLEAR_DETAILS;
}

export interface ClearStatusType {
	type: ActionConstant.CLEAR_STATUS;
}

export interface ClearListType {
	type: ActionConstant.CLEAR_LIST;
}

export type ActionType =
	| GetListType
	| GetDetailsType
	| GetStatusType
	| ClearDetailsType
	| ClearStatusType
	| ClearListType;
